import {
  InformationCircleIcon,
  CurrencyEuroIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline"
import Link from "next/link"

const commonClassGreen =
  "gap-3 rounded-lg flex  bg-green-100 border border-l-4 border-green-500 text-green-700   px-4 py-1 dark:bg-gray-900 dark:text-green-500   dark:border-green-500"
const commonClassYellow =
  "gap-3 rounded-lg flex  bg-yellow-100 border border-l-4 border-yellow-500 text-yellow-700  px-4 py-1 dark:bg-stone-900 dark:text-yellow-200  dark:border-yellow-200"
const commonClassOrange =
  "gap-3 rounded-lg flex  bg-red-100 border border-l-4 border-red-500 text-red-700 2 px-4 py-1 dark:bg-gray-900 dark:text-red-400   dark:border-red-500"

const UnderConstruction = () => {
  return (
    <div className={commonClassGreen} role="alert">
      <div className="basis-1/12">
        <InformationCircleIcon className="v-12 h-12" />
      </div>
      <div>Šiuo metu vyksta atnaujinimo darbai</div>
    </div>
  )
}

const Companies = () => {
  return (
    <div className={commonClassGreen + " flex flex-col"} role="alert">
      <span className="text-2xl font-bold">
        {" "}
        <CurrencyEuroIcon className="inline h-12" /> Įmonėms
      </span>
      <div>
        Ši programa gali būti pritaikyti Jūsų poreikiams.{" "}
        <Link href="/for-companies">Daugiau</Link>
      </div>
    </div>
  )
}

const BestPrice = () => {
  return (
    <p
      className={commonClassYellow + " flex flex-col"}
      role="alert"
      id="best-price"
    >
      <span className="text-2xl font-bold">
        {" "}
        <CurrencyEuroIcon className="inline h-12" /> Geriausia kaina
      </span>
      <span>
        {" "}
        Radote panašią programą už mažesnę kainą? Pirmas kodas pasiruošęs mokymų
        kainą sumažinti iki Jūsų rastos!
      </span>
    </p>
  )
}

const PythonPrerequisite = () => {
  return (
    <div className={commonClassOrange + " flex flex-col"} role="alert">
      <div className="text-2xl font-bold">
        {" "}
        <ExclamationTriangleIcon className="inline h-12" />
        Reikalingos žinios
      </div>
      <div>
        {" "}
        Šie mokymai rekomenduojami turintiems Python programavimo kalbos
        pagrindus. Juos galite įgyti pas mus.{" "}
        <Link href="/courses/python-beginner">Python pradedantiesiems</Link>
      </div>
    </div>
  )
}

export { UnderConstruction, Companies, BestPrice, PythonPrerequisite }
